"use strict";

var _taggedTemplateLiteral = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _slicedToArray = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _templateObject, _templateObject2;

var _excluded = ["disabled", "onChange", "size", "value", "dataTestId", "allowCountryCode"];

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledInputPhoneNumber = exports.InputPhoneNumber = void 0;

var react_1 = __importStar(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var tel_fns_1 = require("tel-fns");

var Input_1 = require("./Input");

var Select_1 = require("./Select");

var DEFAULT_COUNTRY_CODE = tel_fns_1.COUNTRY_CALLING_CODES["US"]; // This might return the incorrect country for a country code, given that multiple countries can share the same country code.
// But I'm considering that acceptable since this only happens if someone already had filled out this input and coming
// back to revisit their answer, in which case if they notice the mistake they'll change it, and if they don't it's harmless

var findCountryFromCountryCode = function findCountryFromCountryCode(countryCode) {
  var keys = Object.keys(tel_fns_1.COUNTRY_CALLING_CODES);
  return keys.sort().sort(function (a) {
    return a === "US" ? -1 : 0;
  }).find(function (key) {
    return tel_fns_1.COUNTRY_CALLING_CODES[key] === countryCode;
  });
}; //("US", "+1") => "US +1"


var getAnnotatedCountryCode = function getAnnotatedCountryCode(country, countryCode) {
  if (country === "" || countryCode === "") {
    return "";
  }

  return "".concat(country, " ").concat(countryCode);
}; //("US +1") => "+1"


var getCountryCodeFromAnnotatedCountryCode = function getCountryCodeFromAnnotatedCountryCode(annotatedCountryCode) {
  var _a;

  return (_a = annotatedCountryCode.split(" ")) === null || _a === void 0 ? void 0 : _a[1];
}; // TODO 1?: The component is the same as one in wizards-of-react. Can it be imported from it instead?


var InputPhoneNumber = function InputPhoneNumber(_ref) {
  var disabled = _ref.disabled,
      onChange = _ref.onChange,
      size = _ref.size,
      value = _ref.value,
      dataTestId = _ref.dataTestId,
      _ref$allowCountryCode = _ref.allowCountryCode,
      allowCountryCode = _ref$allowCountryCode === void 0 ? true : _ref$allowCountryCode,
      props = _objectWithoutProperties(_ref, _excluded);

  var _a, _b;

  var prefilledCountryCode = (0, tel_fns_1.parseTel)(value || "").getCountryCode || DEFAULT_COUNTRY_CODE;
  var prefilledCountry = findCountryFromCountryCode(prefilledCountryCode);
  var prefilledAnnotatedCountryCode = getAnnotatedCountryCode(prefilledCountry || "", prefilledCountryCode);

  var _ref2 = (0, react_1.useState)(prefilledAnnotatedCountryCode),
      _ref3 = _slicedToArray(_ref2, 2),
      annotatedCountryCode = _ref3[0],
      setAnnotatedCountryCode = _ref3[1];

  var _ref4 = (0, react_1.useState)((_b = (_a = (0, tel_fns_1.parseTel)(value || "")) === null || _a === void 0 ? void 0 : _a.getNationalNumber) !== null && _b !== void 0 ? _b : ""),
      _ref5 = _slicedToArray(_ref4, 2),
      phoneNumber = _ref5[0],
      setPhoneNumber = _ref5[1]; // --- onChange


  (0, react_1.useEffect)(function () {
    if (!phoneNumber) {
      onChange(null);
      return;
    }

    var extractedCountryCode = getCountryCodeFromAnnotatedCountryCode(annotatedCountryCode);
    var cleanedPhoneNumber = "".concat(extractedCountryCode).concat(phoneNumber);
    onChange(cleanedPhoneNumber);
  }, [annotatedCountryCode, phoneNumber]); // RENDER

  return react_1.default.createElement(exports.StyledInputPhoneNumber, null, allowCountryCode ? react_1.default.createElement(Select_1.Select, {
    disabled: disabled,

    /*
      The custom prop:
    size : "xs" | "sm" | "md" | "lg"  // TComponentSize -> InputSizesCSS -> StyledComponent<"select", `{..., ${InputSizesCSS} }`, ({..., size })>
      conflicts with the same name HTML select attr:
    size: number | undefined          // React.IntrinsicElements.select.size -> StyledComponent<"select", ...>({..., size })
      However, the issue gets even complicated and odd, as TS error requires:
    size: undefined                   // React.SelectHTMLAttributes<T>.size?: undefined
     */
    // TODO 2: Fix props and types incompatibility
    // "Type string is not assignable to type undefined"
    // @ts-ignore
    size: size,
    value: annotatedCountryCode,
    onChange: function onChange(e) {
      return setAnnotatedCountryCode(e.target.value);
    }
  }, Object.keys(tel_fns_1.COUNTRY_CALLING_CODES).sort().sort(function (a) {
    return a === "US" ? -1 : 0;
  }).map(function (country) {
    var countryAbbr = country;
    var annotatedCountryCode = getAnnotatedCountryCode(country, tel_fns_1.COUNTRY_CALLING_CODES[countryAbbr]);
    return react_1.default.createElement("option", {
      key: annotatedCountryCode,
      value: annotatedCountryCode
    }, annotatedCountryCode);
  })) : react_1.default.createElement(StyledUSCode, null, "+1"), react_1.default.createElement(Input_1.Input, {
    disabled: disabled,
    // TODO 2.1: (see TODO 2 above)
    // @ts-ignore
    mask: "(999) 999-9999",
    size: size,
    type: "tel",
    placeholder: "Phone Number",
    value: phoneNumber,
    onChange: function onChange(e) {
      return setPhoneNumber(e.target.value);
    },
    "data-test-id": dataTestId,
    "data-test-label": props["data-test-label"]
  }));
};

exports.InputPhoneNumber = InputPhoneNumber;
exports.StyledInputPhoneNumber = styled_components_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  height: auto;\n  & > select,\n  & > input {\n    flex-grow: 1;\n    margin: 0;\n  }\n  & > select {\n    max-width: 120px;\n    margin: 0;\n    margin-bottom: 0 !important; // YIKES\n  }\n"])));
var StyledUSCode = styled_components_1.default.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  font-weight: normal;\n  white-space: nowrap;\n  font-size: 16px;\n  min-height: 1.2em;\n  padding: 0px 16px;\n"])));